<nz-modal
  (nzOnCancel)="closeDrawer()"
  (nzOnOk)="add()"
  [nzClosable]="true"
  [nzCloseIcon]="closeIconTpl"
  [nzOkDisabled]="form.invalid || addMutation.isPending()"
  [nzOkLoading]="addMutation.isPending()"
  [nzVisible]="show"
  nzWidth="600px"
  nzOkText="Add Parcel Type"
>
  <ng-template #closeIconTpl>
    <div class="mt-4">
      <span class="fa fa-close"></span>
    </div>
  </ng-template>
  <div *nzModalTitle><span class="fe fe-plus"></span> Add Parcel Type</div>
  <div *nzModalContent>
    <app-error-display *ngIf="showError() && errorDetails" [error]="errorDetails" (dismiss)="onDismissError()" (retry)="add()"></app-error-display>
    
    <div class="mb-4 p-3 border rounded sb-info">
      <p class="text-sm">
        <strong>💡 Tip:</strong> Define parcel categories with size limits. The default cost will be used when this parcel item type is added to routes (you can customize per route later).
      </p>
    </div>

    <form [formGroup]="form" class="grid grid-cols-2 gap-4">
      <nz-form-item class="col-span-2">
        <nz-form-label [nzRequired]="true">Category Name</nz-form-label>
        <nz-form-control nzErrorTip="Please enter a category name (e.g., Small Box, Document)">
          <input
            formControlName="category"
            nz-input
            type="text"
            placeholder="e.g., Small Box, Document, Large Package"
            [disabled]="addMutation.isPending()"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="col-span-2">
        <nz-form-label [nzRequired]="true">Description</nz-form-label>
        <nz-form-control nzErrorTip="Please enter a description">
          <input
            formControlName="description"
            nz-input
            type="text"
            placeholder="e.g., Small packages and boxes up to 5kg"
            [disabled]="addMutation.isPending()"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Max Weight (kg)</nz-form-label>
        <nz-form-control nzErrorTip="Weight cannot be negative">
          <input
            formControlName="maxWeight"
            nz-input
            type="number"
            step="0.1"
            min="0"
            placeholder="0 (no limit)"
            [disabled]="addMutation.isPending()"
          />
          <div class="text-xs text-base-content/60 mt-1">
            Leave as 0 for no weight limit
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Max Volume (m³)</nz-form-label>
        <nz-form-control nzErrorTip="Volume cannot be negative">
          <input
            formControlName="maxVolume"
            nz-input
            type="number"
            step="0.001"
            min="0"
            placeholder="0 (no limit)"
            [disabled]="addMutation.isPending()"
          />
          <div class="text-xs text-base-content/60 mt-1">
            Leave as 0 for no volume limit
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="col-span-2">
        <nz-form-label [nzRequired]="true">Default Cost (UGX)</nz-form-label>
        <nz-form-control nzErrorTip="Cost must be 0 or greater">
          <input
            formControlName="defaultCost"
            nz-input
            type="number"
            step="1000"
            min="0"
            placeholder="e.g., 10000"
            [disabled]="addMutation.isPending()"
          />
          <div class="text-xs text-base-content/60 mt-1">
            This will be the initial cost when this parcel item type is added to routes. You can customize per route later.
          </div>
        </nz-form-control>
      </nz-form-item>
    </form>
  </div>
</nz-modal>
